<template>
  <InfoTableBase
    title-key="table.onlineTutorials"
    :fetch-api="MaintainNewsApi.getTutorialsList"
  />
</template>

<script>
import { MaintainNewsApi } from '@/api';
import InfoTableBase from './components/InfoTableBase.vue';

export default {
  components: { InfoTableBase },
  data: () => ({ MaintainNewsApi }),
};
</script>
